import Icon from '../components/Icon.vue'

Icon.register({
  'file-code': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 97.9c3.9 3.9 7 11.5 7 17zM248 160h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136c0 13.2 10.8 24 24 24zM123.2 400.5l19.6-20.9c0.8-0.9 1.5-2.5 1.5-3.7 0-1.3-0.8-3.2-1.8-4.1l-40.8-35.9 40.8-35.9c1-0.9 1.8-2.7 1.8-4.1 0-1.2-0.7-2.8-1.5-3.7l-19.6-20.9c-0.9-0.9-2.6-1.7-3.9-1.7-1.2 0-2.8 0.7-3.7 1.5l-64.9 60.8c-0.9 0.9-1.7 2.6-1.7 3.9 0 1.3 0.8 3.1 1.7 3.9l64.9 60.8c0.9 0.8 2.5 1.5 3.7 1.5 1.3 0 3.1-0.8 3.9-1.7zM174.5 451c0.4 0.1 1.1 0.2 1.5 0.2 2.2 0 4.6-1.7 5.2-3.9l61.4-211.6c0.1-0.4 0.2-1.1 0.2-1.5 0-2.2-1.7-4.6-3.9-5.2l-27.5-8c-0.4-0.1-1.1-0.2-1.5-0.2-2.2 0-4.6 1.7-5.2 3.9l-61.4 211.6c-0.1 0.4-0.2 1.1-0.2 1.5 0 2.2 1.7 4.6 3.9 5.2zM335.3 339.9c0.9-0.9 1.7-2.6 1.7-3.9 0-1.3-0.8-3.1-1.7-3.9l-64.9-60.8c-0.9-0.8-2.5-1.5-3.7-1.5-1.3 0-3.1 0.8-3.9 1.7l-19.6 20.9c-0.8 0.9-1.5 2.5-1.5 3.7 0 1.3 0.8 3.2 1.8 4.1l40.8 35.9-40.8 35.9c-1 0.9-1.8 2.7-1.8 4.1 0 1.2 0.7 2.8 1.5 3.7l19.6 20.9c0.9 0.9 2.6 1.7 3.9 1.7 1.2 0 2.8-0.7 3.7-1.5z'
      }
    ]
  }
})
